module.exports = "/_next/static/images/a2e1f48d69e5dc516ee85fb7dc726887-kit-photos.png.webp";